// extracted by mini-css-extract-plugin
export var content = "BlogCard-module--content--5b05d";
export var image = "BlogCard-module--image--97d1c";
export var link = "BlogCard-module--link--f885d";
export var root = "BlogCard-module--root--f54f4";